import { createContext, useContext, useState, FC, useCallback } from "react";
import { Modal } from "../components/layout/Modal/Modal";

interface ModalContextProps {
    openModal: (content: React.ReactNode) => void;
    closeModal: () => void;
    closeAllModals: () => void;
    TrainingAreaIdInDestak : string | null;
    setTrainingAreaIdInDestak : (id: string | null) => void;
}

const ModalContext = createContext<ModalContextProps | undefined>(undefined);

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal deve ser usado dentro de um ModalContext');
    }
    return context;
}

export const ModalProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
    const [modalStack, setModalStack] = useState<React.ReactNode[]>([]);
    const [TrainingAreaIdInDestak, setTrainingAreaIdInDestak] = useState<string | null>(null);

    const openModal = useCallback((content: React.ReactNode) => {
        setModalStack(prev => [...prev, content]);
    }, []);

    const closeModal = useCallback(() => {
        setModalStack(prev => prev.slice(0, -1));
    }, []);

    const closeAllModals = useCallback(() => {
        setModalStack([]);
    }, []);

    return (
        <ModalContext.Provider value={{ 
            openModal, 
            closeModal, 
            closeAllModals, 
            TrainingAreaIdInDestak, 
            setTrainingAreaIdInDestak 
            }}>
            {modalStack.map((content, index) => (
                <Modal key={index} index={index}>{content}</Modal>
            ))}
            {children}
        </ModalContext.Provider>
    );
};